import { REJECT_CONFIRM } from "@/lib/pipeline";
import { X, Send, XCircle, Users } from "lucide-react";

const OPTS = [
  { v: "in_process", l: "Poslať na schválenie", icon: Send, cls: "bg-orange-50 border-orange-200 text-orange-800 hover:bg-orange-100" },
  { v: "rejected_shredded", l: "Zamietnuť", icon: XCircle, cls: "bg-red-50 border-red-200 text-red-700 hover:bg-red-100" },
  { v: "rejected_retain", l: "Presunúť do Talent Pool", icon: Users, cls: "bg-teal-50 border-teal-200 text-teal-800 hover:bg-teal-100" },
];

export function FirstDecisionDialog({ name, onDecide, onClose }) {
  const pick = (v) => {
    if (v === "rejected_shredded" && !window.confirm(REJECT_CONFIRM)) return;
    onDecide(v);
  };
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/40 p-4" data-testid="first-decision-dialog" onClick={onClose}>
      <div className="w-full max-w-md rounded-3xl bg-white p-6 shadow-xl animate-in fade-in zoom-in-95" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <h2 className="font-head text-xl font-bold text-[#1e2a5a]">Čo chceš urobiť s týmto kandidátom?</h2>
          <button data-testid="first-decision-close" onClick={onClose} aria-label="Zavrieť" className="text-slate-400 hover:text-slate-700"><X size={20} /></button>
        </div>
        <p className="mt-1 text-sm text-slate-500">{name} · stav Nový</p>
        <div className="mt-5 space-y-2">
          {OPTS.map((o) => (
            <button key={o.v} data-testid={`first-decision-${o.v}`} onClick={() => pick(o.v)}
              className={`w-full flex items-center gap-3 rounded-2xl border px-4 py-3 text-sm font-semibold transition-colors ${o.cls}`}>
              <o.icon size={17} /> {o.l}
            </button>
          ))}
        </div>
        <button data-testid="first-decision-later" onClick={onClose} className="mt-4 w-full text-sm text-slate-500 hover:text-slate-800">Rozhodnem neskôr</button>
      </div>
    </div>
  );
}
